import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui';

const FormCommentReviewHeader = () => (
  <DialogHeader>
    <DialogTitle>
      Commentaire
    </DialogTitle>
    <DialogDescription>
      Un commentaire de description de votre refus.
    </DialogDescription>
  </DialogHeader>
);

export default FormCommentReviewHeader;
